import type EditCommand from "./EditCommand";
import type EditorState from "./EditorState";

export const getInitialState = <T>(data: T): EditorState<T> => ({
  appliedCommands: new Map([]),
  data,
  hasChanges: false,
  revertedChanges: new Map([]),
});

// if edit commands are applied within the same batchThreshold ms timeframe, they are considered a single command in undo/redo action
export const getTimestamp = (batchThresholdMs: number = 500) => {
  const timestamp = Date.now();
  const remainder = timestamp % batchThresholdMs;
  return timestamp - remainder;
};

export const addInMap = <T>(
  map: Map<number, EditCommand<T>[]>,
  timestamp: number,
  ...commands: EditCommand<T>[]
) => {
  const newMap = new Map(map);
  const updatedCommands = [...(newMap.get(timestamp) || []), ...commands];
  newMap.set(timestamp, updatedCommands);
  return newMap;
};
